import "./modules/social";
import "./modules/inline-iframes";
import "./modules/clipboard";
import "./modules/commerce/modals";
import * as Utils from "./modules/utils";
import * as Appeals from "./modules/appeal-banners";
import * as BGVideos from "./modules/bg-videos";
import * as Forms from "./modules/forms";
import * as Donations from "./modules/donations";
import * as Gallery from "./modules/gallery";
import * as CoverVideos from "./modules/cover-videos";
import * as Maps from "./modules/maps";
import * as Faqs from "./modules/faqs";
import * as HorizontalScroll from "./modules/horizontal-scroll";
import * as Audio from "./modules/audio";
import * as EReader from "./modules/ereader";
import * as PDFReader from "./modules/pdf-reader";

// Setup page load transition
Utils.buildPage();

Appeals.init();

// Forms
if (document.querySelector(".js-freeform")) {
    Forms.init();
}

// Donations Form
Donations.init();

// Audio Players
if (document.querySelector(".js-audio-player-container")) {
    Audio.init();
}

// Gallery
if (document.querySelector(".js-gallery-primary-images")) {
    Gallery.init();
}

// EPUB Reader
if (document.querySelector(".js-ereader")) {
    EReader.init();
}

// PDF Reader
if (document.querySelector(".js-pdf-reader")) {
    PDFReader.init();
}

// FAQs
if (document.querySelector(".js-faq")) {
    Faqs.init();
}

// Forced Horizontal Scroll
if (document.querySelector(".js-horizontal-scroll-container")) {
    HorizontalScroll.init();
}

// Initialise Videos (a requirement of the youtube API!)
window.onYouTubeIframeAPIReady = function () {
    // Videos.init();
    BGVideos.init();

    CoverVideos.init();
};

window.initMaps = function () {
    Maps.init();
};
